/*

 */

import React from 'react';

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import VisualizeContainerLoadingIndicator from "../../../clientShared/components/utility/progress/VisualizeContainerLoadingIndicator";
import ErrorInfoDisplay from "../../utilities/displayAreas/ErrorInfoDisplay";

function AdminDisplayPropertyAddress({loading, error, propertyAddress, ...props}) {

    if(error === true){
        return (
            <ErrorInfoDisplay showError={true}>
                Failed to load property address
            </ErrorInfoDisplay>
        );
    }

    if(loading === true || error === true || propertyAddress === undefined){
        return <VisualizeContainerLoadingIndicator loadingResource={propertyAddress} displayName={'Property address'} {...props} />;
    }

    return (
        <React.Fragment>
            {
                Object.keys(propertyAddress).map(
                    accountKey => {
                        return (
                            <React.Fragment key={accountKey}>
                                <b>{accountKey}</b>: {propertyAddress[accountKey].toString()}<br/>
                            </React.Fragment>);
                    }
                )
            }
        </React.Fragment>
    );

}

const mapStateToProps = (state) => ({
});

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators({
    }, dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(AdminDisplayPropertyAddress);